const groupBillSku = (items) => {
  let skus = JSON.parse(JSON.stringify(items))
  let groupSkus = []
  for (const sku of skus) {
    const index = groupSkus.findIndex(item => item.id === sku.id && parseFloat(item.flagPrice) === parseFloat(sku.priceDiscount))
    if (index === -1) {
      sku.priceDiscount = parseFloat(sku.priceDiscount)
      sku.fullPrice = parseFloat(sku.price)
      sku.price = parseFloat(sku.priceDiscount)
      sku.flagPrice = parseFloat(sku.priceDiscount)
      groupSkus.push(sku)
    } else {
      groupSkus[index].amount = parseInt(groupSkus[index].amount) + parseInt(sku.amount)
      groupSkus[index].price = parseFloat(groupSkus[index].price) + (
        parseInt(sku.amount) * parseFloat(sku.priceDiscount))
      groupSkus[index].fullPrice = parseFloat(groupSkus[index].fullPrice) + (
        parseInt(sku.amount) * parseFloat(sku.fullPrice))
    }
  }
  return groupSkus
}
export {
  groupBillSku
}



// WEBPACK FOOTER //
// ./src/utils/modules/print.js